// components/LoginRedirect.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function LoginRedirect() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // ログイン済みの場合は各ユーザータイプのデフォルト画面へ
    const isAuthenticated = !!localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    
    if (isAuthenticated && userType) {
      if (userType === 'admin') {
        navigate('/admin/agency/search');
      } else if (userType === 'agency') {
        const agencyId = JSON.parse(localStorage.getItem('userInfo')).agency_id;
        if (agencyId !== null) {
          navigate(`/agency/detail/${agencyId}`);
        } else {
          navigate('/agency/search');
        }
      } else if (userType === 'solicitor') {
        navigate('/solicitor/insurance/system/search');
      }
      return;
    }
    
    // 選択済みのユーザータイプがある場合はそのログイン画面へ
    if (userType) {
      navigate(`/${userType}/login`, { replace: true });
      return;
    }
    
    // どちらも無い場合は募集人サイトのログイン画面へ
    navigate('/solicitor/login', { replace: true });
  }, [navigate]);
  
  // リダイレクト中の表示
  return <div className="loading">リダイレクト中...</div>;
}

export default LoginRedirect;